module.exports = __webpack_public_path__ + "img/fsm-locked-door.8a24fb8f.jpg";